import React, { ReactNode } from "react";
import { Box, Typography, Stack, Container } from "@mui/material";
import backgroundImage from "url:src/assets/images/background.png";

type Props = {
  title: string;
  children?: ReactNode;
  px?: number;
  titleVariant?: "h5" | "h6";
};

export default function PageHeader({ title, children, px = 2, titleVariant = "h5" }: Props) {
  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "white",
        px,
        py: "40px",
        width: "100%",
      }}
    >
      <Container maxWidth="sm">
        <Stack spacing={2.5} alignItems="center">
          <Typography variant={titleVariant} fontWeight="bold" mb={2.5} textAlign="center">
            {title}
          </Typography>

          {children}
        </Stack>
      </Container>
    </Box>
  );
}
